import { useCallback, useMemo } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Card, Stack, Link, Container, Typography } from '@mui/material';
// routes
import { PATH_APPLY_AUTH, PATH_STUDENT_AUTH } from '../../routes/paths';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import Page from '../../components/Page';
import Logo from '../../components/Logo';
import Image from '../../components/Image';
// sections
import { LoginForm } from '../../sections/auth/login';
import { ConfirmNewPasswordForm } from '../../sections/auth/confirm-new-password';
import useAuth from '../../hooks/useAuth';
import useSettings from '../../hooks/useSettings';

// ----------------------------------------------------------------------
const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  justifyContent: 'center',
  padding: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    padding: theme.spacing(7, 5, 0, 7),
    justifyContent: 'space-between',
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Login({ registerPath, resetPasswordPath }) {
  const { institutionName } = useSettings();
  const { isNewPasswordRequired } = useAuth()
  const smUp = useResponsive('up', 'sm');

  const mdUp = useResponsive('up', 'md');

  const { pathname } = useLocation()

  const section = useMemo(() => {
    // if (pathname.includes('manager')) return 'Manager';
    // if (pathname.includes('inventory')) return 'Inventory';
    // if (pathname.includes('doctor')) return 'Doctor';
    // if (pathname.includes('therapist')) return 'Therapist';
    if (pathname.includes('employee')) return 'Employee';
    if (pathname.includes('patient')) return 'Patient';
    return null
  }, [pathname])

  const ExtraLinks = useCallback(({ align = 'right' }) => (<Stack direction='column' sx={{ mt: 2, ml: 2 }} spacing={1}>
    <Typography variant="body2" align={align}>
      Are you a staff? Login to{' '}
      <Link variant="subtitle2" component={RouterLink} to={PATH_STUDENT_AUTH.login}>
        Student Portal
      </Link>
    </Typography>
  </Stack>), [])

  return (
    <Page title="Login">
      <RootStyle>
        <HeaderStyle>
          <Logo size={!mdUp ? 80 : 64} />
          {/* {mdUp && registerPath && <ExtraLinks />} */}
        </HeaderStyle>

        {mdUp && (
          <SectionStyle>
            <Image visibleByDefault disabledEffect src="/assets/illustrations/illustration_login.png" alt="login" />
          </SectionStyle>
        )}

        <Container maxWidth="sm">
          <ContentStyle>
            <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
              <Box sx={{ flexGrow: 1 }} textAlign={{ xs: 'center', md: 'left' }}>
                <Typography variant="h3" gutterBottom >{institutionName}</Typography>
                <Typography variant="h6" color={'text.secondary'}  >
                  {`${section} Portal`}
                </Typography>
                <Typography sx={{ color: 'text.secondary', fontSize: 'small' }}>Enter your login credentials below.</Typography>
              </Box>

            </Stack>

            {isNewPasswordRequired ? <ConfirmNewPasswordForm /> : <LoginForm resetPasswordPath={resetPasswordPath} registerPath={registerPath} />}

            {/* {!mdUp && registerPath && <ExtraLinks align='center' />} */}
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
